define('social_sharing_flyout.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('social_sharing_flyout', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"social-sharing-flyout-icons\" data-type=\"social-share-icons\"></div>  ";
},"useData":true}, 'extensions/RSM/WestAcademic_Theme/1.0.0/', 'extensions/RSM/WestAcademic_Theme/1.0.0/', Handlebars);
});